module.exports = __webpack_public_path__ + "static/media/bangaluru.ed4fbc16.svg";